import { useTranslation } from "react-i18next";
import { Device } from "../../../features/devices/models/device.model";

export const useDeviceTranslation = () => {
    const { t } = useTranslation();

    const getDeviceTypeTranslation = (device?: Device): string => {
        let title = t([
            `devices:types.${device?.deviceType}`,
            "common:unknown",
        ]);

        if (device?.external) {
            title += ` (${t("devices:external")})`;
        }

        return title;
    };

    return { getDeviceTypeTranslation };
};
